import { NgModule, Component } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DefaultLayoutComponent } from "../layout/default-layout/default-layout.component";
import { DashboardComponent } from "./dashboard.component";
import { PagesComponent } from "./pages/pages.component";
import { WorkDisplayComponent } from "./work-display-component/work-display.component";
import { DirectComponent } from "../direct/page/direct/direct.component";
import { EmdDashboardComponent } from "./emd-dashboard/emd-dashboard.component";
import { StaticDashboardHostComponent } from "./static/static-dashboard-host/static-dashboard-host.component";
const routes: Routes = [
  // Alert Page
  {
    path: ":module/page/alert/config",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/page/alert/config/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: "",
    component: DashboardComponent,
  },
  {
    path: ":module",
    component: DashboardComponent,
  },

  // Default Pages
  {
    path: ":module/page",
    pathMatch: "full",
    component: PagesComponent,
  },

  // Every client-side static / dummy dashboard shares this one route. The host
  // mounts the component registered for the ds_key query param in
  // STATIC_DASHBOARDS, so new static dashboards need no route of their own.
  // Must stay above the ":module/:cardName" catch-all so "static" is not
  // treated as a card name.
  {
    path: ":module/static",
    pathMatch: "full",
    component: StaticDashboardHostComponent,
  },
  // Same route with a bookmark key on the end — what the Bookmarks panel
  // navigates to when one of THIS screen's bookmarks is opened (it appends
  // bookmark_key to the saved url). Without it that url matches
  // ":module/:cardName/:bk_mrk_key" below, i.e. cardName "static", and a static
  // dashboard's bookmark would open the dynamic page flow instead of the
  // dashboard it was taken on. The query params (ds_key, hist_flg) ride along
  // unchanged, so the host mounts the same component in the same view.
  {
    path: ":module/static/:bk_mrk_key",
    pathMatch: "full",
    component: StaticDashboardHostComponent,
  },
  {
    path: ":module/direct/:component",
    pathMatch: "full",
    component: DirectComponent,
  },
  // EMD dashboard page. Reached from DashboardComponent.openPage like any other
  // page tile; must stay ahead of the ":module/:cardName" catch-all below,
  // which would otherwise swallow it into PagesComponent.
  {
    path: ":module/emd-dashboard",
    pathMatch: "full",
    component: EmdDashboardComponent,
  },
  // Case Management's live screens, opened from their FRM tiles
  // (FRM_CASE_MANAGEMENT_DASHBOARDS in dashboard.service.ts). The same lazy
  // module du-admin mounts at `:module/case-management`; its links are relative
  // to its own shell, so it works under either. Must stay ahead of the
  // ":module/:cardName…" catch-alls below, which would swallow its paths.
  {
    path: ":module/case-management",
    loadChildren: () =>
      import("../case-management/case-management.module").then((m) => m.CaseManagementModule),
  },
  {
    path: ":module/page/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:FRM",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:FRM/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
